<template>
  <div class="news">
    <Header></Header>
    <div class="banner-bg">
      <div class="flex-col container banner-title">
        <p class="main-title">中产资讯</p>
        <p class="sub-title">专业 · 精准 · 高效</p>
      </div>
    </div>
  <div class="news-list">
    <nav class="flex-row">
      <li v-for="v in navList" :key="v.name"><a href="javascript:;" :class="{active:active===v.name}" @click="getNewsList(v.name,v.type)">{{v.name}}</a></li>
    </nav>
    <div v-if="newsList.length" class="news-list-container flex-col">
      <div class="news-item flex-row container" v-for="v in newsList" :key="v.id" @click="$router.push({name:'NewsDetail',query:{id:v.id}})">
        <div class="left"><img :src="v.thumb&&v.thumb[0]" alt=""></div>
        <div class="right">
          <div class="top"><span :class="calculateClass(v.categoryText)">{{v.categoryText}}</span>{{v.articleTitle}}</div>
          <div class="middle">{{v.articleDigest}}</div>
          <div class="bottom">{{v.publishTime&&v.publishTime.slice(0,10)}}</div>
        </div>
      </div>
    </div>
    <el-empty v-else description="无数据"></el-empty>
    <div v-if="newsList.length" class="news-list-page container flex-row">
      <el-pagination background :current-page="currPage" layout=" prev, pager, next" :total="total" @current-change="currentChange">
      </el-pagination>
    </div>
  </div>

    <Footer></Footer>
  </div>
</template>

<script>
import '@/assets/css/news.css'
import Header from './Header'
import Footer from './Footer'
export default {
  name: 'News',
  components: {
     Header, Footer
  },
  data(){
    return{
      active: "全部",
      type:'',
      navList: [
        { name: "全部" ,type:''},
        { name: "新闻动态" ,type:'news'},
        { name: "项目预告" ,type:'xmyg'},
        { name: "产业观察" ,type:'cygc'},
        { name: "专题策划" ,type:'ztch'}
      ],
      currPage:1,
      newsList: [],
      total:0,
    }
  },
  watch:{
    $route(n,o){
      if(n.fullPath!=o.fullPath){
        this.currPage=1
        this.active=location.href.indexOf('?')!=-1&&location.href.split('?')[1]?decodeURI(location.href.split('?')[1]):'全部'
        this.getNewsList(this.active,this.navList.find(i=>i.name==this.active).type)
      }
    },
    active(n,o){
      if(n!=o){
        this.currPage=1
      }
    }
  },
  mounted(){
    this.currPage=1
    this.active=location.href.indexOf('?')!=-1&&location.href.split('?')[1]?decodeURI(location.href.split('?')[1]):'全部'
    this.getNewsList(this.active,this.navList.find(i=>i.name==this.active).type)
    // location.hash=''
    // location.href.replace(/#/,'')
    // location.href=location.href.split('#')[0]
  },
  methods: {
    // 获取news列表
    getNewsList (name,type) {
        this.active=name
        this.type=type
        location.hash='#/news?'+encodeURI(this.active)
        this.Axios.post(`/api/index/cms/article/page?currPage=${this.currPage}&size=8`, {category:this.type}).then(res => {
          this.newsList = res.data.data.list
          this.total=res.data.data.total
        })
    },
    // 切换分页
    currentChange (current) {
      this.currPage=current
      this.getNewsList(this.active,this.type)
    },
    // 当前label类名
    calculateClass: function (label) {
      return {
        dynamic: label === '新闻动态',
        trailer: label === '项目预告',
        fallground: label === '项目落地',
        observe: label === '产业观察',
        planning: label === '专题策划',
      }
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/News.vue